import React from 'react';
import './Careers.css';
import careerHero from '../images/career-hero.jpg';
import Header from "../Header/Header"
import HeroSection from '../Components/HeroSection/HeroSection';
import { Container, Row, Col } from 'bootstrap-4-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Footer from '../Footer/Footer';
import axios from 'axios';
import Vacancy from './Vacancy/Vacancy';
import ReactGA from 'react-ga';

class Careers extends React.Component {
    state = {
        jobs: [],
        loading: true,
    }
    componentWillMount() {
        window.scrollTo(0, 0);
    }
    componentDidMount() {
        ReactGA.pageview('/careers');
        axios.get(`moobifunapi/v1/careers?language=en`)
        .then(response => {
            this.setState({
                jobs: response.data.careers,
                loading: false
            });
            
        })
        .catch(function (error) {
            console.log(error);
        });
    }
    render() {
        let loader = <div className="loader-container">
            <i className="fa fa-spinner fa-spin"></i>
        </div>
        const careers = this.state.jobs.map(career => {
            return <Vacancy key={"vacancy "+ career.id}  careerId={career.id} title={career.title} type={career.type} date="jj" location={career.location}/>
        });
        let careers_section = '';
        if (careers.length > 0) {
            careers_section = 
            <div>
                <div className="careers-banner">
                    <Container>
                    <h3>Your Career Starts Here</h3>
                    <span>Our mission interests you and you share our values? Join us!</span>
                    </Container>
                </div>
                <Container className="vacancies-list">
                    <Row>
                        <Col col="lg-10 md-12 12" offset="lg-1">
                            <Row>
                            {careers}
                            </Row>
                            {/* <a className="load-more main-btn" href="#">Load More</a> */}
                        </Col>
                    </Row>
                </Container>
            </div>;
        }
       return (
        <div className="careers-page">
            <Header />
            <HeroSection background={careerHero} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/careers/" className="current">Careers</Link></li>
                    </ul>
                </Container>
                <div className="careers">
                    <h2 className="second-title"><i className="fa fa-circle"></i> <span>Join Our Team </span><i className="fa fa-circle"></i></h2>
                    <Container>
                        <p className="page-intro">
                        Moobifun is a close-knit team working in a professional and stimulating environment. We combine an entrepreneurial spirit with a structure designed to support our growth ambitions.
                        </p>
                    </Container>
                    <section className="careers-list">
                         {this.state.loading ? loader : careers_section}
                    </section>
                </div>
            </section>
            <Footer/>
        </div>
       );
    }
}
export default Careers;
